const Snackbar = require('../components/snackbar');
var gtm = require('googletagmanager/tagManager');
const $wishlistIcon = $('.wishlist-icon');
const $wishlistFilledIcon = $('.wishlist-filled-icon');
const $ProductWishlistContainer = $('.product-detail__wishlist-btn-container');
const $ProductWishlistIcon = $ProductWishlistContainer.find('.wishlist-icon');
const $ProductWishlistFilledIcon = $ProductWishlistContainer.find('.wishlist-filled-icon');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();
    if (data.success) {
        if (icon.hasClass('fa-heart-o')) {
            icon.removeClass('fa-heart-o').addClass('fa-heart');
        }
    }

    const messageType = data.success ?  'success' : 'error';
    Snackbar.show({
        type: messageType,
        position: 'left',
        message: data.msg
    });
}

/**
 * Gets update of wishlist status on load
 */
function getWishlistStatus() {
    var $url = $('.js-wishlist-status').data('status');

    // Check if URL is valid
    if (!$url) {
        console.error('Wishlist status URL is missing.');
        return;
    }

    $.get($url, function(response) {
        const items = (response && response.list && Array.isArray(response.list.items)) ? response.list.items : [];
        if (items.length > 0) {
            $wishlistIcon.addClass('d-none');
            $wishlistFilledIcon.removeClass('d-none');
            $ProductWishlistIcon.removeClass('d-none');
            $ProductWishlistFilledIcon.addClass('d-none');
        } else {
            $wishlistIcon.removeClass('d-none');
            $wishlistFilledIcon.addClass('d-none');
        }

    }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error('Failed to fetch wishlist status:', textStatus, errorThrown);
        // Optional: Set fallback UI state or retry logic here
    });
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var $this = $(this);
            var icon = $(this).find($('i'));
            var $product = $(this).closest('.product');
            var $activeSwatch = $product.find('.color-swatches .swatch-link.swatch-active .swatch');
            var pid;
            if ($activeSwatch.length && $activeSwatch.data('variant-id') !== null) {
                pid = $activeSwatch.data('variant-id');
            } else {
                pid = $product.attr('data-pid');
            }
            var wishlistRemoveUrl = $this.attr('data-remove-url');
            var mergeWishlistWithId = wishlistRemoveUrl + '?pid=' + pid;
            var url = $this.hasClass('active') ? mergeWishlistWithId : $this.attr('href');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            var productIndex = $product.find('.product-tile').data('gtm-product-index');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }
            var productListName = ($this.data('product-list-name') || '').toString().toUpperCase();
            if (!productListName) {
                var $productTile = $product.find('.product-tile');
                productListName = $productTile ? ($productTile.data('gtm-product-list-name') || '').toString().toUpperCase() : '';
            }
            var isPlp = $this.attr('data-is-plp');

            $.spinner().start();
            if (!$this.hasClass('active')) {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        productIndex: productIndex,
                        optionVal: optionVal,
                        productListName: productListName,
                        isPlp: isPlp,
                        csrf_token: $('[name="csrf_token"]').val()
                    },
                    success: function (data) {
                        $this.toggleClass('active');
                        displayMessageAndChangeIcon(data, icon);
                        $wishlistIcon.addClass('d-none');
                        $wishlistFilledIcon.removeClass('d-none');
                        gtm.eAddToFav(data); 
                    },
                    error: function (err) {
                        displayMessageAndChangeIcon(err, icon);
                    }
                });
            } else {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {
                        productListName: productListName,
                        isPlp: isPlp,
                    },
                    success: function (data) {
                        $this.toggleClass('active');
                        $this.trigger('blur');
                        displayMessageAndChangeIcon(data, icon);
                        getWishlistStatus();
                    },
                    error: function (err) {
                        displayMessageAndChangeIcon(err, icon);
                    }
                });
            }
        });
    }
};
